"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.getTheme = exports.resetClassName = void 0;
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const theme_ui_1 = require("theme-ui");
const useId_1 = require("../../hooks/useId");
const useOverlay_1 = require("../../hooks/useOverlay");
const Fonts_1 = require("../Fonts");
const IconContext_1 = require("../Icon/IconContext");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("./ThemeContext");
const types_1 = require("./types");
exports.resetClassName = "mdrna-reset";
const ResetStyles = () => {
    const fontFacesDeclaration = react_2.default.useMemo(() => (0, Fonts_1.getFontFacesDeclaration)(), []);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(theme_ui_1.Global, { styles: {
                [`.${exports.resetClassName}`]: {
                    all: "unset",
                    cursor: "revert",
                    display: "revert",
                    verticalAlign: "baseline"
                },
                "*": {
                    WebkitTapHighlightColor: "transparent"
                }
            } }),
        react_2.default.createElement(react_1.Global, { styles: (0, react_1.css) `
          ${fontFacesDeclaration}
        ` })));
};
const getTheme = (themeBranding) => {
    const space = new Array(192)
        .fill(null)
        .map((_value, i) => i * 4);
    const spaceType = Object.assign(Object.assign({}, space), Theme_1.Space);
    return {
        breakpoints: ["720px", "1024px", "1440px", "1920px"],
        colors: Object.assign(Object.assign({}, Theme_1.SystemColors), (0, types_1.setColorsForTheme)(themeBranding || Theme_1.ModernaBrand)),
        space: spaceType,
        sizes: Object.assign(Object.assign({}, spaceType), { containerDesktopMargin: 64, containerDesktopMaxWidth: 1440, containerMobileMargin: 16, containerMobileMaxWidth: 748, containerTabletMargin: 40, containerTabletMaxWidth: 748, gridDesktopColumnGutter: 32, gridMobileColumnGutter: 16, gridTabletColumnGutter: 24 }),
        shadows: Theme_1.Elevation,
        radii: Theme_1.CornerRadii,
        fontSizes: Theme_1.FontSize,
        fontWeights: Theme_1.FontWeight,
        lineHeights: Theme_1.LineHeight,
        letterSpacings: Theme_1.LetterSpacing,
        fonts: {
            // TODO: refactor?
            body: "Aeonik",
            code: "RobotoMono"
        },
        grid: {
            // TODO: refactor?
            gridDesktopColumnCount: 12,
            gridMobileColumnCount: 4,
            gridTabletColumnCount: 8
        },
        config: {
            useCustomProperties: false,
            useLocalStorage: false
        },
        transitions: {
            "transition-color-medium": "background-color 100ms, border-color 100ms, color 100ms, opacity 100ms, box-shadow 100ms, outline-color 100ms, text-decoration-color 100ms",
            "transition-color-slow": "background-color 300ms, border-color 300ms, color 300ms, opacity 300ms, box-shadow 300ms, outline-color 300ms, text-decoration-color 300ms",
            "transition-ease-out-fast": "background-color 100ms, border-color 100ms, color 100ms, opacity 100ms, box-shadow 100ms, text-decoration-color 100ms, transform 300ms cubic-bezier(0.4, 0, 0, 1)",
            "transition-ease-out-medium": "background-color 200ms, border-color 200ms, color 200ms, opacity 200ms, box-shadow 200ms, text-decoration-color 200ms, transform 400ms cubic-bezier(0.4, 0, 0.06, 1)",
            "transition-ease-out-slow": "background-color 400ms, border-color 400ms, color 400ms, opacity 400ms, box-shadow 400ms, text-decoration-color 400ms, transform 800ms cubic-bezier(0.4, 0, 0.06, 1)"
        },
        zIndices: {
            dropdown: 1200,
            modal: 1300,
            navbar: 1100,
            panel: 1150
        }
    };
};
exports.getTheme = getTheme;
const ThemeProvider = ({ children, mode = "light", themeBranding = Theme_1.ModernaBrand, preCacheIcons = [] }) => {
    const { initialized } = react_2.default.useContext(ThemeContext_1.ThemeContext);
    const theme = (0, exports.getTheme)(themeBranding);
    const themeContextNext = react_2.default.useMemo(() => ({
        initialized: true,
        mode,
        themeInitial: Object.assign({}, theme)
    }), [mode, theme]);
    return initialized ? (react_2.default.createElement(react_2.default.Fragment, null, children)) : (react_2.default.createElement(useId_1.IdProvider, null,
        react_2.default.createElement(useOverlay_1.OverlayContextProvider, null,
            react_2.default.createElement(ThemeContext_1.ThemeContext.Provider, { value: themeContextNext },
                react_2.default.createElement(theme_ui_1.ThemeUIProvider, { theme: theme },
                    react_2.default.createElement(IconContext_1.IconProvider, { preCacheIcons: preCacheIcons },
                        react_2.default.createElement(ResetStyles, null),
                        children))))));
};
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=Theme.js.map